import { useAmendmentsFilter } from './useAmendmentsFilter';
import { useGetAmendmentsQuery } from '../services';
import usePagination from '@/hooks/usePagination';
import type { AmendmentsFilter } from '../models';

const DEFAULT_PAGE_SIZE = 20;

export const useAmendmentHistory = () => {
  const { filter, setFilter } = useAmendmentsFilter();

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({ initialPage: 1, initialPageSize: DEFAULT_PAGE_SIZE });

  const { data, isLoading } = useGetAmendmentsQuery({
    ...(filter.shippingNumber && { shippingNumber: filter.shippingNumber }),
    ...(filter.transitionId && { transitionId: filter.transitionId }),
    ...(filter.from && { from: filter.from instanceof Date ? filter.from.toISOString() : new Date(filter.from).toISOString() }),
    ...(filter.to && { to: filter.to instanceof Date ? filter.to.toISOString() : new Date(filter.to).toISOString() }),
    limit: pageSize,
    offset: (currentPage - 1) * pageSize,
  });

  return {
    amendments: data?.items ?? [],
    totalItems: data?.count ?? 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
    isLoading,
    filter,
    setFilter: (newFilter: AmendmentsFilter) => {
      setFilter(newFilter);
      handlePageChange(1);
    },
    currentPage,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
  };
};
